import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "toast-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "toast__icon" }
const _hoisted_4 = { class: "toast__message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "toast" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
          return (_openBlock(), _createElementBlock("div", {
            key: toast.id,
            class: _normalizeClass(['toast', `toast--${toast.type}`]),
            onClick: ($event: any) => (_ctx.dismiss(toast.id))
          }, [
            _createElementVNode("span", _hoisted_3, [
              (toast.type === 'success')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("✓")
                  ], 64))
                : (toast.type === 'error')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("✗")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode("ⓘ")
                    ], 64))
            ]),
            _createElementVNode("span", _hoisted_4, _toDisplayString(toast.message), 1)
          ], 10, _hoisted_2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}